import { LuSearch } from "@/Components/Icons/Icons";
export default {
  row1: [
    {
      column: "column1",
      columnWidth: "45%",
      rows: {
        row1: [
          {
            name: "Thirt Party Info",
            component: "header",
          },
        ],
        row2: [
          {
            name: "thirdPartyName",
            label: "Name",
            component: "text-field",
            icon: LuSearch,
            width: "87.5%",
            responseKey: "data",
            labelKey: "label",
            valueKey: "value",
            type: "autocomplete",
            endpoint: "getCustomers",
            autofillTargets: {
              exportInvoiceThirdPartyAddress: "addressLine",
              exportInvoiceThirdPartyCity: "city",
              exportInvoiceThirdPartyState: "state",
              exportInvoiceThirdPartyCountry: "country",
              exportInvoiceThirdPartyPincode: "pincode",
            },
            endPointWithId : "getCustomersAddress"
          },
          {
            name: "new",
            label: "New",
            component: "backlink",
            sx: {
              mt: 3,
            },
          },
        ],
        row3: [
          {
            name: "exportInvoiceThirdPartyAddress",
            component: "textarea",
            width: "95.5%",
            sx: {
              minHeight: "10%",
              borderRadius: 10,
            },
            // isGet : false,
            // type: "autocomplete",
          },
        ],
        row5: [
          {
            name: "exportInvoiceThirdPartyCity",
            label: "City",
            component: "text-field",
            width: "40%",
            type: "autocomplete",
            endpoint: "getCity",
            icon: LuSearch,
            dependsOn: "exportInvoiceThirdPartyState",
            useLinkedValue: "exportInvoiceThirdPartyState",
          },
          {
            name: "exportInvoiceThirdPartyPincode",
            label: "PIN",
            component: "text-field",
            width: "44%",
          },
        ],

        row7: [
          {
            name: "exportInvoiceThirdPartyCountry",
            label: "Country",
            component: "text-field",
            width: "87%",
            icon: LuSearch,
            type: "autocomplete",
            endpoint: "getCountry",
            linkedValue: "exportInvoiceThirdPartyCountry",
          },
        ],
        row8: [
          {
            name: "exportInvoiceThirdPartyState",
            label: "State",
            component: "text-field",
            width: "87%",
            type: "autocomplete",
            icon: LuSearch,
            endpoint: "getState",
            useLinkedValue: "exportInvoiceThirdPartyCountry",
            linkedValue: "exportInvoiceThirdPartyState",
          },
        ],
      },
    },
    {
      column: "column2",
      columnWidth: "45%",
      rows: {
        row1: [
          {
            name: "Buyer Info",
            component: "header",
          },
        ],
        row2: [
          {
            name: "buyerName",
            label: "Name",
            component: "text-field",
            icon: LuSearch,
            width: "87.5%",
            type: "autocomplete",
            endpoint: "getCustomers",
            autofillTargets: {
              exportInvoiceBuyerAddress: "addressLine",
              exportInvoiceBuyerCity: "city",
              exportInvoiceBuyerState: "state",
              exportInvoiceBuyerCountry: "country",
              exportInvoiceBuyerPincode: "pincode",
            },
            disabled: true,
            endPointWithId : "getCustomersAddress"
          },
          {
            name: "new",
            label: "New",
            component: "backlink",
            sx: {
              mt: 3,
            },
          },
        ],
        row3: [
          {
            name: "exportInvoiceBuyerAddress",
            component: "textarea",
            width: "95.5%",
            sx: {
              minHeight: "10%",
              borderRadius: 10,
            },
          },
        ],
        row5: [
          {
            name: "exportInvoiceBuyerCity",
            label: "City",
            component: "text-field",
            width: "40%",
            type: "autocomplete",
            endpoint: "getCity",
            icon: LuSearch,
            dependsOn: "exportInvoiceBuyerState",
            useLinkedValue: "exportInvoiceBuyerState",
          },

          {
            name: "exportInvoiceBuyerPincode",
            label: "PIN",
            component: "text-field",
            width: "44%",
          },
        ],

        row7: [
          {
            name: "exportInvoiceBuyerCountry",
            label: "Country",
            component: "text-field",
            width: "87%",
            icon: LuSearch,
            type: "autocomplete",
            endpoint: "getCountry",
            linkedValue: "exportInvoiceBuyerCountry",
          },
        ],
        row8: [
          {
            name: "exportInvoiceBuyerState",
            label: "State",
            component: "text-field",
            width: "87%",
            type: "autocomplete",
            endpoint: "getState",
            icon: LuSearch,
            useLinkedValue: "exportInvoiceBuyerCountry",
            linkedValue: "exportInvoiceBuyerState",
          },
        ],
      },
    },
  ],
};
